/* ============================================================
   HEMP LIFE - education page reveals (Gravity XL)

   Adds .is-in to .edu-reveal elements as they enter the
   viewport. Purely decorative: the CSS shows everything by
   default under prefers-reduced-motion, and if this script
   never runs the fallback below still reveals the content, so
   copy is never trapped behind JS.
   ============================================================ */
(function () {
  'use strict';

  function showAll() {
    var all = document.querySelectorAll('.edu-reveal');
    for (var i = 0; i < all.length; i++) all[i].classList.add('is-in');
  }

  function init() {
    var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if ((mq && mq.matches) || !('IntersectionObserver' in window)) {
      showAll();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-in');
          io.unobserve(entries[i].target);
        }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    var nodes = document.querySelectorAll('.edu-reveal');
    for (var j = 0; j < nodes.length; j++) io.observe(nodes[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);

  // last resort - if anything above failed, never leave content hidden
  window.setTimeout(function () {
    var hidden = document.querySelector('.edu-reveal:not(.is-in)');
    if (hidden && !hidden.getBoundingClientRect().height) showAll();
  }, 3000);
})();
